import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, CreditCard, Lock } from 'lucide-react';
import { Button } from './ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from './ui/card';

const SubscriptionLockedModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleRenew = () => {
    navigate('/subscription');
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <Card className="max-w-md w-full">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
            <Lock className="h-8 w-8 text-red-600" />
          </div>
          <CardTitle className="text-xl text-red-600">Account Locked</CardTitle>
          <CardDescription>
            Your Pro subscription has expired
          </CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4">
            <div className="flex items-start">
              <AlertTriangle className="h-5 w-5 text-amber-500 mr-3 mt-0.5" />
              <div>
                <p className="text-sm text-amber-800">
                  Your account access has been temporarily restricted because your subscription has expired.
                </p>
                <p className="text-sm text-amber-700 mt-2">
                  Don't worry - all your data is safe! Renew your subscription to regain full access.
                </p>
              </div>
            </div>
          </div>

          <div className="bg-gray-50 rounded-lg p-4">
            <p className="font-medium text-gray-800 mb-2">Renew to restore access to:</p>
            <ul className="text-sm text-gray-600 space-y-1">
              <li>• All your programs and athletes</li>
              <li>• Attendance tracking</li>
              <li>• Reports and exports</li>
              <li>• Team collaboration</li>
            </ul>
          </div>

          <Button 
            onClick={handleRenew}
            className="w-full h-12"
            style={{ backgroundColor: '#007A3D' }}
          >
            <CreditCard className="h-5 w-5 mr-2" />
            Renew Now - $29/year
          </Button>

          <p className="text-xs text-center text-gray-500">
            Questions? Contact us at info@attendancetracker.ws
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default SubscriptionLockedModal;
